module.exports = __webpack_public_path__ + "static/img/1.6c2b3fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/eng/1.png
// module id = Opgt
// module chunks = 0